module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('block-blank-form', {
    attrs: {
      "submit-label": "Добавить подъезд",
      "block": _vm.block,
      "errors": _vm.errors,
      "form-type": "add"
    },
    on: {
      "submit": _vm.processBlockForm
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b8b49c8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/block/BlockAddForm.vue
// module id = 612
// module chunks = 0